export const GET_ITEM_DETAILS_PROCESS = "GET_ITEM_DETAILS_PROCESS";
export const GET_ITEM_DETAILS_START = "GET_ITEM_DETAILS_START";
export const GET_ITEM_DETAILS_SUCCESS = "GET_ITEM_DETAILS_SUCCESS";
